import { render, staticRenderFns } from "./TheArticleCitation.vue?vue&type=template&id=0cedf955&"
import script from "./TheArticleCitation.vue?vue&type=script&lang=js&"
export * from "./TheArticleCitation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports